module.exports = __webpack_public_path__ + "public/images/netw-start-conversation-mobile.18f31281da96c927ee58e996254752ee.jpg";